import { useExperimentVariables } from '@mc/experiments-react'

const INTRO_PRICING_FLAG_NAME = 'prcng-338_v1'

// copied from web/apps/checkout/src/experiements/prcng-338_v1_intro_pricing/shouldShowIntroPricing.ts
const INTRO_PRICING_COUPON_PREFIX = 'intro_pricing'

const isIntroPricingCoupon = (code: string) =>
  code.startsWith(INTRO_PRICING_COUPON_PREFIX)

export const useHideCouponsIntroPricingExperiment = (discountSlug: string) => {
  const variables = useExperimentVariables(INTRO_PRICING_FLAG_NAME)

  const hide =
    // if coupon matches with the exp dummy coupon
    (variables?.coupon && variables.coupon === discountSlug) ||
    // if coupon matches with the real exp applied coupons
    isIntroPricingCoupon(discountSlug)

  return hide
}
